import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'
import { getOrdersV2, searchOrdersV2 } from '../../../api/outboundorders/orders'

const initialState = {
  isFetchingOrders: false,
  fetchOrdersError: null,
  /* Orders displayed in the table */
  orders: [],
  /* Total number of orders */
  totalOrdersCount: 0,
  /* Order which user selects from the table */
  selectedOrder: null,
}

/* Fetch all orders */
export const fetchOrders = createAsyncThunk(
  'order/fetchOrders',
  async (args, { rejectWithValue }) => {
    const request = {
      pageNo: args.page,
      pageSize: args.pageSize,
      sortDirection: args.sortDirection,
      sortProperty: args.sortProperty,
    }
    try {
      const response = await getOrdersV2(request)
      return response
    } catch (exception) {
      return rejectWithValue(exception)
    }
  },
)

/* Fetch orders based on search criteria */
export const searchOrders = createAsyncThunk(
  'order/searchOrders',
  async (args, { rejectWithValue }) => {
    const request = {
      pageNo: args.page,
      pageSize: args.pageSize,
      sortDirection: args.sortDirection,
      sortProperty: args.sortProperty,
      searchBy: args.filterBy,
      searchValue: args.filterValue,
    }
    try {
      return await searchOrdersV2(request)
    } catch (exception) {
      return rejectWithValue(exception)
    }
  },
)

const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    setSelectedOrder: (state, action) => {
      state.selectedOrder = action.payload
    },
    resetSelectedOrder: (state) => {
      state.selectedOrder = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrders.pending, (state) => {
        state.isFetchingOrders = true
        state.orders = []
        state.totalOrdersCount = 0
        state.selectedOrder = null
        state.fetchOrdersError = null
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.isFetchingOrders = false
        state.orders = action.payload?.data?.data
        state.totalOrdersCount = action.payload?.headers?.totalrows
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.isFetchingOrders = false
        state.fetchOrdersError = action.payload
      })
      .addCase(searchOrders.pending, (state) => {
        state.isFetchingOrders = true
        state.orders = []
        state.totalOrdersCount = 0
        state.selectedOrder = null
        state.fetchOrdersError = null
      })
      .addCase(searchOrders.fulfilled, (state, action) => {
        state.isFetchingOrders = false
        state.orders = action.payload.data.data
        state.totalOrdersCount = action.payload.headers.totalrows
      })
      .addCase(searchOrders.rejected, (state, action) => {
        state.isFetchingOrders = false
        state.fetchOrdersError = action.payload
      })
      .addCase('orderAllocationsSummary/fetchOrderAllocationsSummary/pending', () => {
        return initialState
      })
      .addCase('orderAllocations/fetchOrderAllocations/pending', () => {
        return initialState
      })
      /* Action which gets triggered
         when running persistor.purge() */
      .addCase(PURGE, () => {
        return initialState
      })
  },
})

export const { setSelectedOrder, resetSelectedOrder } = orderSlice.actions

export default orderSlice.reducer
